export default __webpack_public_path__ + "static/media/gallery42.9d888c0d.webp";